<template>
  <form @submit.prevent="SendSuggestionValidate">
    <InputLabel
      v-model="InfoMessage.name"
      placeholder="Perrucho"
      class="mb-4"
      label="Nombre"
      type="text"
      full
    />
    <TextAreaLabel
      v-model="InfoMessage.message"
      label="Mensaje"
      placeholder="Hola, estaría bueno tener una herramienta..."
      :rows="8"
      required
      full
      block
    />
    <Button
      type="submit"
      :loading="LoadingStateSubmitBtn"
      class="mt-4 w-full md:w-auto"
      variant="primary"
      roudness
      >ENVIAR</Button
    >
  </form>
</template>

<script setup lang="ts">
import { ref, reactive } from "vue";
import TextAreaLabel from "@/components/molecules/textAreaLabel/textAreaLabel.vue";
import InputLabel from "@/components/molecules/inputLabel/InputLabel.vue";
import Button from "@/components/atoms/BaseButton.vue";
import { InfoSuggestion } from "@/types/data.type";
import { SendEmail } from "@/services/middlewares/sendSuggestion.middleware";

// Vuelidate
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";

// Notification
import { ShowNotification } from "@/helpers/notification.helper";

const InfoMessage: InfoSuggestion = reactive({
  name: "",
  message: "",
});

const validationRules = {
  name: { required },
  message: { required },
};

const v$ = useVuelidate(validationRules, InfoMessage);
const LoadingStateSubmitBtn = ref(false);

const SendSuggestionValidate = async () => {
  try {
    const validation = await v$.value.$validate();
    if (validation) {
      LoadingStateSubmitBtn.value = true;
      await SendEmail(InfoMessage);
      LoadingStateSubmitBtn.value = false;
    } else{
          ShowNotification(
      "Falta información",
      "Recuerda completar toda la información para poder enviar la sugerencia.",
      "warning"
    );
    }
  } catch (e) {
    LoadingStateSubmitBtn.value = false;
  }
};
</script>
